module.exports = __webpack_public_path__ + "img/asafo-agyei.91bbfa06.jpg";